import { useCurrentAccount } from '@application/api';
import type { Route } from '@application/types';
import { useRouter, useSavedApplication } from '@application/utils';
import { UnfinishedApplication } from '@presentation/components';
import { useCallback, useEffect, useMemo, useState } from 'react';
import { toast } from 'react-toastify';

const EXCLUDED_ROUTES: Route[] = ['application', 'breeder', 'litter'];

export const UnfinishedApplicationController = () => {
  const { closePopup, isUnfinished, clearOngoingApplication, breederId } = useSavedApplication();
  const { currentAccount, currentAccountType } = useCurrentAccount();
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const { infoFromCurrentPath } = useRouter();

  const shouldShowPopup = useMemo(() => {
    return (
      isOpen &&
      !EXCLUDED_ROUTES.includes(infoFromCurrentPath.route) &&
      currentAccountType !== 'breeder'
    );
  }, [currentAccountType, infoFromCurrentPath.route, isOpen]);

  useEffect(() => {
    setIsOpen(isUnfinished && !!breederId);
  }, [breederId, isUnfinished]);

  const onCloseClickHandler = useCallback(() => {
    toast.dismiss(breederId as string);
    setIsOpen(false);
    clearOngoingApplication();
  }, [breederId, clearOngoingApplication]);

  const onGoToApplicationClickHandler = useCallback(() => {
    toast.dismiss(breederId as string);
    closePopup();
    setIsOpen(false);
  }, [breederId, closePopup]);

  useEffect(() => {
    if (shouldShowPopup) {
      toast(
        () => (
          <UnfinishedApplication
            userFirstName={currentAccount?.firstName}
            breederId={breederId}
            onCloseClick={onCloseClickHandler}
            onGoToApplicationClick={onGoToApplicationClickHandler}
          />
        ),
        {
          toastId: breederId as string,
          autoClose: isOpen ? false : 1,
          closeButton: false,
          closeOnClick: false,
          position: 'top-right',
          style: { marginTop: 60 },
        },
      );
    } else {
      toast.dismiss(breederId as string);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldShowPopup]);

  return null;
};
